<script>
  import { onMount, onDestroy } from "svelte";
  import request from 'superagent';
  import { createEventDispatcher } from 'svelte';
  import { Editor } from '@tiptap/core';
  import StarterKit from '@tiptap/starter-kit';
  import Underline from '@tiptap/extension-underline';
  const dispatch = createEventDispatcher();
  
  export let content = '<p>Hello 🌍️ </p>';
  export let visible_font_sizes =  true;
  
  let editor;
  let element;
  
  onMount(() => {
    editor = new Editor({
      element: element,
      extensions: [
        StarterKit,
        Underline
      ],
      editorProps: {
        attributes: {
          class: 'droplet',
        },
      },
      content: content,
      onTransaction: () => {
        // force re-render so `editor.isActive` works as expected
        editor = editor
      },
    })
  });
  
  onDestroy(() => {
    if (editor) {
      editor.destroy()
    }
  })
</script>
<slot></slot>
<div bind:this='{element}' class='ui w-100 p-1'></div>
{#if editor}
<div class='d-flex justify-content-start'>
<div class='econtrol d-flex justify-content-around w-50'>
<div class='btn-group'>
<button class:active='{editor.isActive('underline')}' class='btn btn-sm' on:click|preventDefault='{() => editor.chain().focus().toggleUnderline().run()}'>
<u>
U
</u>
</button>
<button class:active='{editor.isActive('italic')}' class='btn btn-sm' on:click|preventDefault='{() => editor.chain().focus().toggleItalic().run()}'>
<em>
I
</em>
</button>
<button class:active='{editor.isActive('bold')}' class='btn btn-sm' on:click|preventDefault='{() => editor.chain().focus().toggleBold().run()}'>
<strong>
B
</strong>
</button>
</div>
{#if visible_font_sizes}
<div class='btn-group'>
<button class:active='{editor.isActive('heading', { level: 2 })}' class='btn btn-sm' on:click|preventDefault='{() => editor.chain().focus().setHeading({ level: 2 }).run()}'>
<i class='fa fa-font fa-2x'></i>
</button>
<button class:active='{editor.isActive('paragraph')}' class='btn btn-sm' on:click|preventDefault='{() => editor.chain().focus().setParagraph().run()}'>
<i class='fa fa-font'></i>
</button>
</div>
{/if}
</div>
</div>
{/if}
